import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { CUSTOM_BUTTON_VARIANT, CustomButton } from 'src/components/CustomButton';
import { getImageOverlayTextFieldTitle, IMAGE_OVERLAY_TEXT_FIELD } from 'src/data/image';

import { ScoredTextField } from './components/ScoredTextField';
import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  onFieldChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  disabled: PropTypes.bool,
  hideActions: PropTypes.bool,
  grayoutTitle: PropTypes.bool,
  displayPrefix: PropTypes.bool,
  disableAutoFocus: PropTypes.bool,
  classes: PropTypes.shape({}),
};
const defaultProps = {
  className: '',
  classes: null,
  data: {},
  onSubmit: null,
  onCancel: null,
  disabled: false,
  hideActions: false,
  grayoutTitle: false,
  displayPrefix: false,
  disableAutoFocus: false,
};

export const ImageOverlayForm = forwardRef(
  (
    {
      className,
      data = {},
      onFieldChange,
      onSubmit,
      onCancel,
      disabled,
      hideActions,
      displayPrefix,
      classes,
      grayoutTitle,
      disableAutoFocus,
    },
    ref
  ) => {
    const styles = useStyles({ classes });

    const createInputChangeHandler = (type) => (event) => {
      onFieldChange(type, event.target.value);
    };

    const handleSubmit = (event) => {
      event.preventDefault();
      onSubmit();
    };

    return (
      <form className={cx(styles.root, className)}>
        <div className={styles.content}>
          {Object.values(IMAGE_OVERLAY_TEXT_FIELD).map((type, index) => (
            <ScoredTextField
              grayoutTitle={grayoutTitle}
              className={styles.input}
              key={type}
              value={data[type]?.text || ''}
              onChange={createInputChangeHandler(type)}
              label={getImageOverlayTextFieldTitle(type, { displayPrefix })}
              score={data[type]?.score}
              loadingScore={data[type]?.loading || false}
              disabled={disabled}
              autoFocus={disableAutoFocus ? false : index === 0}
            />
          ))}
        </div>

        {!hideActions && (
          <div className={styles.footer}>
            <CustomButton
              onClick={onCancel}
              disabled={disabled}
              variant={CUSTOM_BUTTON_VARIANT.text}
            >
              Cancel
            </CustomButton>
            <CustomButton
              onClick={handleSubmit}
              disabled={disabled}
              type="submit"
            >
              Apply
            </CustomButton>
          </div>
        )}
      </form>
    );
  }
);

ImageOverlayForm.displayName = 'ImageOverlayForm';
ImageOverlayForm.propTypes = propTypes;
ImageOverlayForm.defaultProps = defaultProps;
